
namespace GeniuzPOS.InventoryReport {
    import fld = IcReport04_VRow.Fields;
    @Serenity.Decorators.registerClass()
    export class IcReport04_VGrid extends Serenity.EntityGrid<IcReport04_VRow, any> {
        protected getColumnsKey() { return IcReport04_VColumns.columnsKey; }
        protected getDialogType() { return IcReport04_VDialog; }
        protected getIdProperty() { return IcReport04_VRow.idProperty; }
        protected getInsertPermission() { return IcReport04_VRow.insertPermission; }
        protected getLocalTextPrefix() { return IcReport04_VRow.localTextPrefix; }
        protected getService() { return IcReport04_VService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions): any {
            // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            // let columns = Object.keys(options.columnStyles)

            let descriptions: string[] = [];
            let a = QRreport.QRywcSpecRow.getLookup().itemById["52"].GruopType;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if(a==1){
                descriptions.push("สรุปยอดคงเหลือตามหมวดสินค้า1");
            }
            if(a==2){
                descriptions.push("สรุปยอดคงเหลือตามหมวดสินค้า2");
            }
            if(a==3){
                descriptions.push("สรุปยอดคงเหลือตามหมวดสินค้า3");
            }
            if(a==4){
                descriptions.push("สรุปยอดคงเหลือตามแบรนด์");
            }            
            
            return [descriptions, gridColumns];
        }
        // protected createQuickSearchInput() {
        // }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcReport04_VService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            let reportTitle = 'รายงานสินค้าคงเหลือสรุปตามกลุ่มสินค้า'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "Grouptype", title: "ประเภท", isHidden: true, },
                1: { field: "GroupCode", title: "รหัส", cellWidth: 30, overflow: 'linebreak', },
                2: { field: "GroupName", title: "กลุ่ม", cellWidth: 60, overflow: 'linebreak', },
                3: { field: "QtyOnHand", title: "จำนวน", cellWidth: 25, halign: 'right', aggregate: "sum" },
                4: { field: "StockCostValue", title: "มูลค่า", cellWidth: 25, halign: 'right', aggregate: "sum" }


            }

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     pageSize: { width: 210, height: 297 },
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     }
            // }));
            //--ยังตั้งendpoint model ไม่ผ่าน ??
            // let pdfButton: Serenity.ToolButton =
            // {
            //     title: "ExportPdf",
            //     hint: "ExportPdf",
            //     separator: true,
            //     cssClass: 'export-pdf-button',
            //     icon: "fa fa-save",
                

            //     onClick: (e) => {

            //         const request = this.getView().params
            //         // request.SkuCode = item.SkuCode
            //         Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' });

            //     }

            // }
            // buttons.push(pdfButton)
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpec_icrp04/edit/52';
                        return false;
                    },
                }
            );
            return buttons;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }


        protected createSlickGrid() {
            var grid = super.createSlickGrid();


            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('QtyOnHand'),
                    new Slick.Aggregators.Sum('StockCostValue')

                ]
            });
            return grid;
        }
        // protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

        //     let filters = super.getQuickFilters();
        //     Q.first(filters, x => x.field == fld.Grouptype).init = w => {
        //         (w as Serenity.EnumEditor).value = "ยี่ห้อ";
        //         ;
        //     };
    
            
    
        //     return filters;
        // }
    }
}